import { CheckoutView } from './CheckoutView';
import { CheckoutLegacySkin } from './CheckoutLegacySkin';
import { accentVars } from './accent';
import type { PublicCheckout } from './contract';
import type { CheckoutTrackingIdentifiers, CheckoutUtmAttribution } from './attribution';
import { localeDirection, useCheckoutLocale } from '../i18n';
import { LanguageSelector } from './LanguageSelector';
import { checkoutSkinFor } from './usePublicCheckout';
import './checkout.css';

export function CheckoutRenderer({
  checkout,
  preview = false,
  affiliateRef,
  utm,
  trackingIdentifiers,
  recuperaaiCartId,
  refreshCheckout,
  ensureCheckoutSession,
  onActivity,
  onBusyChange,
}: {
  checkout: PublicCheckout;
  preview?: boolean;
  affiliateRef?: string | undefined;
  utm?: CheckoutUtmAttribution | undefined;
  trackingIdentifiers?: CheckoutTrackingIdentifiers | undefined;
  recuperaaiCartId?: string | undefined;
  refreshCheckout?: (() => Promise<PublicCheckout>) | undefined;
  ensureCheckoutSession?: ((force?: boolean) => Promise<string | undefined>) | undefined;
  onActivity?: (() => void | Promise<unknown>) | undefined;
  onBusyChange?: ((busy: boolean) => void) | undefined;
}) {
  const locale = useCheckoutLocale(checkout.pricing?.country, checkout.pricing?.currency);
  const skin = checkoutSkinFor(checkout);
  const Skin = skin === 'legacy' ? CheckoutLegacySkin : CheckoutView;
  return (
    <div
      className="vp-root"
      data-template={checkout.presentation.template}
      data-skin={skin}
      lang={locale}
      dir={localeDirection(locale)}
      style={accentVars(checkout.presentation.accent)}
    >
      <div className="vp-language-bar">
        <LanguageSelector />
      </div>
      <Skin
        checkout={checkout}
        preview={preview}
        affiliateRef={affiliateRef}
        utm={utm}
        trackingIdentifiers={trackingIdentifiers}
        recuperaaiCartId={recuperaaiCartId}
        refreshCheckout={refreshCheckout}
        ensureCheckoutSession={ensureCheckoutSession}
        onActivity={onActivity}
        onBusyChange={onBusyChange}
      />
    </div>
  );
}
